import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b5eb874"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "EngineeringList" }
const _hoisted_2 = { class: "listItem" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "desc" }
const _hoisted_5 = { class: "action" }
const _hoisted_6 = { class: "time" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("查看详情")
const _hoisted_8 = { class: "tagWarpper" }
const _hoisted_9 = { class: "tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanList = _resolveComponent("VanList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VanList, {
      class: "list",
      modelValue: $setup.loading,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.loading) = $event)),
      finished: $setup.finished,
      "finished-text": "没有更多了",
      onLoad: $setup.getList,
      "immediate-check": false
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (item, idx) => {
          return (_openBlock(), _createBlock($setup["ListItemAd"], {
            data: idx%5 == 0?$setup.addList[idx/5]:{},
            key: idx
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, _toDisplayString(item.title), 1),
                _createElementVNode("div", _hoisted_4, "用苗地区：" + _toDisplayString(item.receiptAddress), 1),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.createTime), 1),
                  _createVNode(_component_VanButton, {
                    size: "mini",
                    color: "#ffcc32",
                    onClick: ($event: any) => ($setup.push({name:"EngineeringDetail",query:{id:item.id}}))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_7
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.categories, (item, idx) => {
                      return (_openBlock(), _createBlock(_component_VanTag, {
                        color: "red",
                        plain: "",
                        key: `tag${idx}`
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item), 1)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _withDirectives(_createElementVNode("div", { class: "quote" }, "已有" + _toDisplayString(item.quotations) + "条报价", 513), [
                    [_vShow, item.quotations]
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["data"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue", "finished"])
  ]))
}